import { MetadataController } from './metadata-controller';
import model from './model';
import type { ControllerParams } from './types';

export type PostMetadataApi = MetadataController['exports'];

export default model.createController(
  (params) => new MetadataController(params as ControllerParams),
);
